import React from 'react';
import styles from './styles.module.scss';

interface SectionContentProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Padded flex-column wrapper for the body of `MainSection`. Provides standard
 * tab-content padding (`var(--container-gutter)`) and `gap: 20px` between children.
 *
 * Use this on tabs that render one or more inner cards inside `MainSection`
 * and need consistent breathing room around them (DetailsTab, PredictionsTab,
 * LeaderboardTab). Without it, the body would be flush with the section edges.
 */
export const SectionContent: React.FC<SectionContentProps> = ({ children, className }) => (
  <div className={`${styles.container} ${className || ''}`}>{children}</div>
);

export default SectionContent;
